
// https://github.com/microsoft/pxt-radio-blockchain/blob/master/main.ts
// MIT Lincense
// Copyright (c) Microsoft Corporation. All rights reserved.
// https://github.com/microsoft/pxt-radio-blockchain/blob/master/LICENSE
export function computeHash(str) {
  let s = '' + str
  /**
     * dbj2 hashing, http://www.cse.yorku.ca/~oz/hash.html
     */
  let hash = 5381
  for (let i = 0; i < s.length; i++) {
    let c = s.charCodeAt(i)
    hash = ((hash << 5) + hash) + c /* hash * 33 + c */
  }
  return hash & 0xffff
}
